import { render, staticRenderFns } from "./Conteudo.vue?vue&type=template&id=2d51db12&"
import script from "./Conteudo.vue?vue&type=script&lang=js&"
export * from "./Conteudo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports